import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';
import { saveDistprojectOrder } from 'store/actions';

const initialState = {
    distributionTree: [],
    distributions: {},
    activeDistribution: null,
    order: [],
    error: null,
    loading: false,
    distsByType: {}
};

const getDistributionTreeStart = (state, action) => {
    return updateObject( state, { error: null, loading: true } );
}

const getDistributionTreeFail = (state, action) => {
    return updateObject( state, {
        error: action.error,
        loading: false
    });
}

// function wrap child distributions into children of distribution
const getDistributionChildren = (level) => {
    // init children object
    let children = [];
    // init length counter
    let length = 0;
	
	//let saveOrder = false;
    // check if level has children
    if (level.children.length > 0) {
        // process children
        level.children.forEach((item, index) => {
            // init item
            let _item = item.project;
            // update object with metadata
            updateObject(_item, item.project.data.metadata.fields);
            // set created (for sorting)
            _item['created'] = item.project.metadata.fields.created;
            _item['isChild'] = true;
            // append distribution
            children[length] = _item;
            children[length]['name'] = item.project.name;
            children[length]['children'] = getDistributionChildren(item);
            // increment length
            length ++;
        });
    }
	
	children.sort(function(a, b) {
		if (parseInt(a.getMetadata().fields.Order) < parseInt(b.getMetadata().fields.Order)) { return -1; }
		if (parseInt(a.getMetadata().fields.Order) > parseInt(b.getMetadata().fields.Order)) { return 1; }
		return 0;
	});
	
    return children;
};

const getDistributionTreeSuccess = (state, action) => {
    
    // init distribution tree
    let distributionTree= [];
    // init length counter
    let length = 0;
    // process first level
    action.children.forEach((item, index) => {
        // init item
        let _item = item.project;
        // update object with metadata
        updateObject(_item, item.project.data.metadata.fields);
        // set created (for sorting)
        _item['created'] = item.project.metadata.fields.created;
        _item['isChild'] = false;
        // append distribution
        distributionTree[length] = _item;
        distributionTree[length]['name'] = item.project.name;
        distributionTree[length]['children'] = getDistributionChildren(item);
        // increment length
        length ++;
    });

    // init flat list of distributions
    let distributions = {};
    // function to flatten distribution tree
    const flattenTree = function(children) {
        // loop through children
        children.forEach((item, index) => {
            // init item
            let _item = {};
            // set data
            _item = item.data;
            // set meta
            updateObject(_item, item.data.metadata.fields);
            // set created
            _item['created'] = item.created;
			_item.children = item.children;
            // store in flat list
            distributions[item.data.id] = _item;
            // check for childs
            if(item.children.length > 0) {
                // append children
                flattenTree(item.children);
            }
        });
    };
    // execute flatten function
    flattenTree(distributionTree);

    return updateObject(state, {
        distributionTree: distributionTree,
        distributions: distributions,
        loading: false
    });
}

const saveOrder = (changed) => {
	if(!changed) {
		return;
	}
	
	
}

const checkRelations = (list) => {
    
}

const getChilds = (obj) => {
    const elms = obj.getLinks().elements;
    const childIds = [];
    if(elms) {
        elms.forEach(elm => {
            if(elm.getRelation() === "child") {
                childIds.push(elm.getTarget_id());
            }
        });
    }
    return childIds;
}

const hasParent = (obj) => {
    const elms = obj.getLinks().elements;
    let parent = false;
    if(elms) {
        elms.forEach(elm => {
            if(elm.getRelation() === "parent") {
                parent = true;
            }
        });
    }
    return parent;
}

const mapFields = (elm, fields) => {
    const obj = {};
    fields.forEach(key => {
        if(key in elm.data.metadata.fields) {
            obj[key] = elm.data.metadata.fields[key];
        }
    });
    return obj;
}

const createStructures = (res, type, config = {}) => {
    const elms = res.objects.elements;
    const struct = {};
    const tree = {};
    const fields = (config.DIST_TREE_FIELDS && config.DIST_TREE_FIELDS[type]) || false;
    
    if(elms) {
        // build list
        for(let key in elms) {
            // set default values
            struct[key] = { id: key, title: elms[key].name };
            // combine default values with field mapping if exists
            struct[key] = { ...struct[key], ...((fields && mapFields(elms[key], fields)) || {}) };
            // add child ids
            struct[key].childIds = getChilds(elms[key]);
            struct[key].children = {};
        }
        // build tree
        for(let key in struct) {
            if(!hasParent(elms[key])) {
                tree[key] = struct[key];
                struct[key].parentId = 0;
            }
            struct[key].childIds.forEach(id => {
                if(struct[id]) {
                    struct[key].children[id] = struct[id];
                    struct[id].parentId = key;
                }
            });
        }
    }
    
    return { tree, struct };
}
// Need for Tag Tree View

const createTreeList = (tags, projects) => {
    const list = {};
    for(let id in tags) {
        // NOT NEEDED let lvl = tags[id].cat;
        //let childs = stock[id].refids.map;
        list[id] = { id: id, name: tags[id].data.name, desc: tags[id].data.name, usecount: 0, childIds: projects.struct[id].childIds, parentIds: [] };
        /*if(lvl) {
            tags[id].level = lvl;
        }*/
    }

    return list;
}

const getAllChildIds = (tags) => {
    let childIds = [];
    Object.values(tags).forEach(tag => {
        childIds = [ ...childIds, ...tag.childIds ];
    });
    return childIds;
}

const getChildsX = (tags, ids, parents) => {
    const res = [];
    ids.forEach(id => {
        if(tags[id]) {
            // set all parent ids (child -> parent -> parent -> ...)
            const parentIds = [ ...tags[id].parentIds, ...parents];
            tags[id].parentIds = parentIds;
            res.push(tags[id]);
        } else {
            console.log("ID not exists: " + id);
        }
    });
    return res;
    //return ids.map(id => tags[id]);
}

const createTree = (tags) => {
    const tree = [];
    const allChilds = getAllChildIds(tags);
    
    //console.log(allChilds);
    
    for(let id in tags) {
        if(!allChilds.includes(parseInt(id))) {
            tree.push(tags[id]);
        }
        // set all parent ids to child
        const parentIds = [ ...tags[id].parentIds, id ];
        tags[id].children = [ ...getChildsX(tags, tags[id].childIds, parentIds) ];
        //delete tags[id].childIds;
    }
    
    return tree;
}

const reducer = ( state = initialState, action) => {
    // need for dist by type operations
    let distsByType;
    
    switch (action.type) {
        case actionTypes.GET_DISTRIBUTION_TREE_START: return getDistributionTreeStart(state, action);
        case actionTypes.GET_DISTRIBUTION_TREE_SUCCESS: return getDistributionTreeSuccess(state, action);
        case actionTypes.GET_DISTRIBUTION_TREE_FAIL: return getDistributionTreeFail(state, action);
        case actionTypes.GET_DISTRIBUTIONS_BY_TYPE_START:
            distsByType = state.distsByType;
            if(!distsByType[action.distType]) {
                distsByType[action.distType] = {};
            }
            distsByType[action.distType].loading = true;
            return updateObject(state, { distsByType: distsByType });
        case actionTypes.GET_DISTRIBUTIONS_BY_TYPE_SUCCESS:
            const struct = createStructures(action.res, action.distType, action.config);
            struct.res = action.res;
            struct.list = action.res.objects.elements;
            struct.loading = false;
            if(action.distType === "projects") {
                struct.tagTreeList = createTreeList(struct.list, struct);
                struct.tagTree = createTree(struct.tagTreeList);
            }
            distsByType = state.distsByType;
            distsByType[action.distType] = struct;
            return updateObject(state, { distsByType: distsByType });
        case actionTypes.GET_DISTRIBUTIONS_BY_TYPE_FAIL:
            distsByType = state.distsByType;
            distsByType[action.distType].loading = false;
            return updateObject(state, { distsByType: distsByType });
		case actionTypes.DISTRIBUTION_REORDER_START: return updateObject( state, {  loading: true } );
        case actionTypes.DISTRIBUTION_REORDER_SUCCESS: return updateObject( state, {  loading: false } );
        default: 
            return state;
    }
}

export default reducer;
